import posthog from 'posthog-js';
import Cookies from 'js-cookie';

const { site } = document.documentElement.dataset;

function overrideFeatureFlagsFromCookie() {
  const flags = Cookies.get('feature_flags');
  const flagsForOverride = flags ? JSON.parse(flags) : [];

  const flagsObject = flagsForOverride.reduce((acc, { key, variant, active }) => {
    acc[key] = variant || active;
    return acc;
  }, {});

  posthog.featureFlags.override(flagsObject);
}

window.overrideFeatureFlagsFromCookie = overrideFeatureFlagsFromCookie;

function maskedSensitiveParams(url) {
  if (url.indexOf('?') === -1) return url;

  const queryString = url.split('?')[1];
  const searchParams = new URLSearchParams(queryString);

  const sensitiveParams = [
    'access_token',
    'refresh_token',
    'token',
    'id_token',
    'code',
    'otl',
  ];

  sensitiveParams.forEach((param) => {
    if (searchParams.has(param)) {
      searchParams.set(param, '***hidden***');
    }
  });

  return `${url.split('?')[0] }?${ searchParams.toString()}`;
}

const posthogInstance = process.env.POSTHOG_API_KEY ? posthog.init(
  process.env.POSTHOG_API_KEY,
  {
    api_host: 'https://eu.posthog.com',
    capture_pageleave: false,
    capture_pageview: false,
    disable_session_recording: true,
    session_recording: {
      maskAllInputs: false,
    },
    bootstrap: {
      site,
    },
    sanitize_properties(properties, _event) {
      if (properties.$current_url) {
        properties.$current_url = maskedSensitiveParams(properties.$current_url);
      }
      return properties;
    },
    autocapture: {
      dom_event_allowlist: ['click'],
      css_selector_allowlist: ['[ph-autocapture]'],
    },
  },
) : null;

if (posthogInstance) {
  posthogInstance._instanceId = `init_${new Date().getTime()}`;

  posthog.setPersonPropertiesForFlags({ site });

  window.posthog = posthogInstance;
}

export default posthogInstance;
